import { type ReactNode } from 'react'
import { Button, Tooltip } from '@asus-common/fe-ui-shadcn'

interface ButtonWithTooltipProps {
  id?: string
  label: string
  tooltipContent: string
  isValid: boolean
  isSubmitting: boolean
  endIcon?: ReactNode
}

export function ButtonWithTooltip({
  id,
  label,
  tooltipContent,
  isValid,
  isSubmitting,
  endIcon,
}: ButtonWithTooltipProps) {
  return (
    <Tooltip
      content={tooltipContent}
      disabled={isValid}
      contentProps={{ side: 'top' }}
    >
      <Button
        id={id}
        type="submit"
        variant="solid"
        status="primary"
        size="md"
        loading={isSubmitting}
        endIcon={endIcon}
        disabled={!isValid || isSubmitting}
      >
        {label}
      </Button>
    </Tooltip>
  )
}
